import type { ReactNode } from 'react';
import type { VariantProps } from 'class-variance-authority';
import type { inputVariants } from '@shared/components/ui/input';

import { useId } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { Select, SelectValue, SelectContent, SelectTrigger } from '@shared/components/ui/select';

import { FieldShell } from './field-shell';

type Props = VariantProps<typeof inputVariants> & {
  name: string;
  label?: ReactNode;
  helperText?: ReactNode;
  placeholder?: string;
  disabled?: boolean;
  /** Type du champ RHF : les `SelectItem` ont toujours des valeurs `string` */
  valueType?: 'string' | 'number';
  containerClassName?: string;
  /** `SelectItem` */
  children: ReactNode;
};

export const RHFSelect = ({
  name,
  label,
  helperText,
  placeholder,
  disabled,
  valueType = 'string',
  size,
  containerClassName,
  children,
}: Props) => {
  const { control } = useFormContext();
  const id = useId();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState: { error } }) => (
        <FieldShell className={containerClassName} error={error?.message} helperText={helperText} id={id} label={label}>
          <Select
            disabled={disabled}
            onValueChange={(value) => field.onChange(valueType === 'number' ? Number(value) : value)}
            // `0` / vide = aucune sélection (convention du projet pour les listes de motifs)
            value={!field.value ? '' : String(field.value)}
          >
            <SelectTrigger aria-invalid={error ? true : undefined} id={id} onBlur={field.onBlur} size={size}>
              <SelectValue placeholder={placeholder} />
            </SelectTrigger>
            <SelectContent>{children}</SelectContent>
          </Select>
        </FieldShell>
      )}
    />
  );
};
